export const name = 'userImageController';

export default function userImageController(
  $mdDialog,
  $mdToast,
  $gzAnalytics,
  $q,
  $scope,
  $translate,
  rnHttp,
  Upload,
  $window
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  // Constants
  const PORTAL_SERVICE_NAME = 'portal_service';
  const PORTAL_USER_IMAGE_API_PATH = 'profile/image';

  // View Model
  let vm = this;

  //   VM properties
  vm.isLoading = true;
  vm.sending = false;
  vm.errorKey = null;
  vm.currentProfileImageSrc = null;
  vm.inputFile = null;
  vm.editing = false;
  vm.useDefaultImage = false;
  vm.image = {
    src: null,
    cropped: null
  };

  //   VM methods
  vm.updateOrDeleteImage = updateOrDeleteImage;
  vm.useDefault = useDefault;
  vm.disableSubmit = disableSubmit;
  vm.close = close;
  vm.cancel =cancel;
  vm.validateFile = validateFile;

  vm.activate = activate;
  activate();

  //////////////

  function activate() {
    vm.options = {
      viewport: {
        width: 100,
        height: 100,
        type: 'circle'
      },
      boundary: {width: 150, height: 150},
    };

    let promises = [];
    promises.push(getCurrentProfileImageFromServer());
    return $q.all(promises)
    .catch((error) => {
      vm.errorKey = 'uxf.uxf.Error_UnableToGetData';
    })
    .finally(() => {
      vm.isLoading = false;
    });
  }

  function getCurrentProfileImageFromServer() {
    return rnHttp.get(PORTAL_SERVICE_NAME, 'profile').then(response => {
      vm.currentProfileImageSrc = _.get(response, 'data._links.image.href', null);
      if (vm.currentProfileImageSrc) {
        // Tack on cachebuster param
        vm.currentProfileImageSrc += '?v=' + (new Date()).getTime();
      }
      else {
        vm.useDefaultImage = true;
      }
    })
    .catch(() => {
      vm.useDefaultImage = true;
    });
  }

  function validateFile(file) {
    if (!file) {
      return;
    }
    vm.errorKey = null;
    readFile(file)
      .then(src => {
        return testImageSource(src)
          .then(() => {
            vm.editing = true;
            vm.image.src = src;
          });
      })
      .catch(error => {
        vm.editing = false;
        vm.inputFile = null;
        vm.errorKey = 'uxf.uxf.ChangeProfileImage_FileError';
      });
  }

  function readFile(file) {
    return $q((resolve, reject) => {
      let reader = new $window.FileReader();
      reader.onloadend = e => {
        let url = e.target.result;
        let error = e.target.error;
        if (error != null) {
          reject('Error reading file: ' + error);
        }
        else {
          resolve(url);
        }
      };
      reader.readAsDataURL(file);
    });
  }

  function testImageSource(url) {
    // Catch error before binding invalid file to croppie
    // Adapted from https://stackoverflow.com/questions/9809015/image-onerror-event-never-fires-but-image-isnt-valid-data-need-a-work-around
    return $q((resolve, reject) => {
      let image = new $window.Image();
      image.onload = function() {
        if (_.get(this, 'naturalHeight')) {
          if (this.naturalHeight + this.naturalWidth === 0) {
            this.onerror();
          }
        }
        else if (this.width + this.height === 0) {
          this.onerror();
        }
        resolve(image.src);
      };
      image.onerror = () => {
        reject('Error: invalid image source');
      };
      image.src = url;
    });
  }

  function updateOrDeleteImage() {
    if (_.get(vm, 'image.cropped')) {
      updateImage();
    }
    else {
      deleteImage();
    }
  }

  function updateImage() {
    let image = vm.image.cropped;
    vm.sending = true;
    vm.errorKey = null;

    return sendFileToPortal(image).then(response => {
      let userId = _.get(response, 'data.userId');
      $gzAnalytics.eventSave('user profile image changed',
        {label: 'user id: ' + userId});
      vm.errorKey = null;
      $mdToast.showSimple($translate.instant('uxf.uxf.ChangeProfileImage_Updated'));
      close();
    })
    .catch(error => {
      ga('send', 'exception', {
        exDescription: 'user profile image changed failed: ' + _.get(error, 'smsError.message', 'unknown')
      });
      vm.errorKey = 'uxf.uxf.GenericError';
    })
    .finally(() => {
      vm.sending = false;
    });
  }

  function sendFileToPortal(file) {
    let fd = new $window.FormData();
    fd.append('file', file);
    let config = {transformRequest: angular.identity, headers: {'Content-Type': undefined}, rhino: {allowUndefinedContentType: true}};
    return rnHttp.post(PORTAL_SERVICE_NAME, PORTAL_USER_IMAGE_API_PATH, fd, config);
  }

  function useDefault($event) {
    $event.stopPropagation();
    vm.useDefaultImage = true;
  }

  function deleteImage() {
    vm.sending = true;
    vm.errorKey = null;

    return rnHttp.delete(PORTAL_SERVICE_NAME, PORTAL_USER_IMAGE_API_PATH).then((response) => {
      let userId = _.get(response, 'data.userId');
      $gzAnalytics.eventSave('user profile image reset',
        {label: 'user id: ' + userId});
      vm.currentProfileImageSrc = null;
      vm.errorKey = null;
      $mdToast.showSimple($translate.instant('uxf.uxf.ChangeProfileImage_ResetToDefault'));
      close();
    })
    .catch(error => {
      ga('send', 'exception', {
        exDescription: 'user profile image changed failed: ' + _.get(error, 'smsError.message', 'unknown')
      });
      vm.errorKey = 'uxf.uxf.GenericError';
    })
    .finally(() => {
      vm.sending = false;
    });
  }

  function disableSubmit() {
    return vm.sending === true || (vm.editing === false && vm.useDefaultImage === false);
  }

  function close() {
    $mdDialog.hide();
  }

  function cancel() {
    $mdDialog.cancel();
  }
}
